import type { DocNode, Inline } from '@atlaskit/adf-schema';
import type { Skill } from '@atlassian/rovo-platform-types/skills';

export const ROVO_SKILL_EXTENSION_TYPE = 'com.atlassian.rovo.skill';
export const ROVO_SKILL_EXTENSION_KEY = 'skill';
export const ROVO_SKILL_QUICK_INSERT_ACTION_KEY = 'skillTag';
export const ROVO_SKILL_TAG_PATTERN: RegExp = /\/([a-zA-Z0-9-]+)/g;
/**
 * Extension key is returned to us from ReactRenderer in a combined format
 */
export const ROVO_SKILL_COMBINED_EXTENSION_KEY: 'skill:skillTag' = `${ROVO_SKILL_EXTENSION_KEY}:${ROVO_SKILL_QUICK_INSERT_ACTION_KEY}`;
/**
 * Temporary type used for feature gating skills on the frontend
 */
export type SkillQuickInsert = Omit<Skill, 'id'> & {
	id?: string;
	featureGateName?: string;
};

export const isSkillTagExtension = (extensionType: string, extensionKey: string): boolean => {
	return (
		extensionType === ROVO_SKILL_EXTENSION_TYPE &&
		extensionKey === ROVO_SKILL_COMBINED_EXTENSION_KEY
	);
};

export const createSkillNode = (skill: Skill | SkillQuickInsert): Inline[] => {
	return [
		{
			type: 'inlineExtension',
			attrs: {
				extensionKey: ROVO_SKILL_COMBINED_EXTENSION_KEY,
				extensionType: ROVO_SKILL_EXTENSION_TYPE,
				parameters: skill,
			},
		},
		// render an empty space after the skill tag
		{ type: 'text', text: ' ' },
	];
};

export const createSkillAdf = (skill: Skill): DocNode => ({
	type: 'doc',
	version: 1,
	content: [
		{
			type: 'paragraph',
			content: createSkillNode(skill),
		},
	],
});
